import { render, staticRenderFns } from "./balance_content.vue?vue&type=template&id=ef771a0c&"
import script from "./balance_content.vue?vue&type=script&lang=js&"
export * from "./balance_content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports